import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getExamById,
  getExamResultbyId,
  getExamResults,
  submitAssignment,
} from "../services/MockExamService.js";
import NavbarComponent from "./NavbarComponent.js";
import HeroWrapComponent from "./HelloWorldComponent.js";
import FooterComponent from "./FooterComponent.js";
import ExamContainer from "./ExamContainer.js";
import ExamInfo from "./ExamInfo.js";
import LoadingComponent from "./LoadingComponent.js";
import { isNumeric } from "../common/common.js";
import { getUserInfoById } from "../services/UserService.js";

const ExecuteTest_TSA_Component = (props) => {
  const {} = props;
  const { examId } = useParams();
  const navigate = useNavigate();
  const [examResult, setExamResult] = useState(null);
  const [examResults, setExamResults] = useState(null);
  const [examData, setExamData] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isStarted, setIsStarted] = useState(false);
  const [userAnswers, setUserAnswers] = useState(null);
  const [questions, setQuestions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [maxScore, setMaxScore] = useState(10);
  const remainingTimeLocal = localStorage.getItem(`countdownTime_${examId}`);
  const [remainingTime, setRemainingTime] = useState(
    remainingTimeLocal ? JSON.parse(remainingTimeLocal) : 0
  );

  const onDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination) return;

    const question = questions.find((e) => e.question === source.droppableId); // Giả sử chỉ có một câu hỏi, bạn có thể điều chỉnh để hỗ trợ nhiều câu hỏi

    const draggedItem = question.items[source.index];

    // Nếu thả vào ô trống (slot)
    if (destination.droppableId.startsWith("slot")) {
      const slotKey = destination.droppableId;
      const previousItemInSlot = question.answers[slotKey];

      setQuestions((prevQuestions) => {
        const updatedQuestions = [...prevQuestions];
        const oldQuestion = updatedQuestions.find(
          (e) => e.question === source.droppableId
        );
        // Cập nhật ô trống với item được kéo thả vào
        oldQuestion.answers[slotKey] = draggedItem;

        // Xóa item khỏi danh sách items
        oldQuestion.items = oldQuestion.items.filter(
          (item) => item.id !== draggedItem.id
        );

        // Nếu có item trước đó trong ô trống, đưa nó trở lại danh sách items
        if (previousItemInSlot) {
          oldQuestion.items.push(previousItemInSlot);
        }
        setUserAnswers((prevAnswers) => {
          const newAnswer = {
            ...prevAnswers,
            [source.droppableId]: {
              ...prevAnswers[source.droppableId],
              [slotKey]: draggedItem.id,
            },
          };
          localStorage.setItem(
            `userAnswers_${examId}`,
            JSON.stringify(newAnswer)
          );
          return newAnswer;
        });
        localStorage.setItem(
          `questions_${examId}`,
          JSON.stringify(updatedQuestions)
        );
        return updatedQuestions;
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getExamResultbyId(examId, "TSA");
        if (
          response &&
          response.data &&
          response.data.data &&
          response.status === 200
        ) {
          let { data } = response.data;
          setExamResult(data);
          setIsStarted(data?.isStarted);
          setIsCompleted(data?.isCompleted);
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        toast.error(message);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, [examId, isCompleted]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getExamResults(examId, "TSA");
        if (
          response &&
          response.data &&
          response.data.data &&
          response.status === 200
        ) {
          const { data } = response.data;
          setExamResults(data);
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        toast.error(message);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, [examId, isCompleted]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userPesponse = await getUserInfoById();
        const response = await getExamById(examId);
        if (
          userPesponse &&
          userPesponse.data &&
          userPesponse.data.data &&
          response &&
          response.data &&
          response.data.data &&
          response.status === 200
        ) {
          let { data } = response.data;
          setMaxScore(response.data.maxScore);
          if (!data.active && userPesponse.data.data.role !== 1) {
            navigate("/exam-papers");
            return;
          }

          localStorage.setItem(
            `questions_${examId}`,
            JSON.stringify(data?.questions)
          );
          setQuestions(data?.questions);

          const localUserAnswers = localStorage.getItem(
            `userAnswers_${examId}`
          );
          if (!localUserAnswers) {
            setUserAnswers((prevAnswers) => {
              let newPrevAnswers = { ...prevAnswers };
              Array.isArray(data?.questions) &&
                data?.questions.forEach((q) => {
                  if (q.type === "TN") {
                    newPrevAnswers = { ...newPrevAnswers, [q.question]: "" };
                  } else if (q.type === "DS") {
                    newPrevAnswers = {
                      ...newPrevAnswers,
                      [q.question]: { a: "", b: "", c: "", d: "" },
                    };
                  } else if (q.type === "KT") {
                    newPrevAnswers = {
                      ...newPrevAnswers,
                      [q.question]: {
                        slot1: "",
                        slot2: "",
                        slot3: "",
                        slot4: "",
                      },
                    };
                  } else if (q.type === "TLN_M") {
                    newPrevAnswers = {
                      ...newPrevAnswers,
                      [q.question]: { "1.": "", "2.": "", "3.": "", "4.": "" },
                    };
                  } else if (q.type === "TLN") {
                    newPrevAnswers = {
                      ...newPrevAnswers,
                      [q.question]: null,
                    };
                  } else if (q.type === "MA") {
                    newPrevAnswers = {
                      ...newPrevAnswers,
                      [q.question]: [],
                    };
                  } else if (q.type === "MQ") {
                    newPrevAnswers = {
                      ...newPrevAnswers,
                    };
                  } else {
                    toast.error(`Câu hỏi không hợp lệ: ${q?.question}`);
                  }
                });
              return newPrevAnswers;
            });
          } else {
            setUserAnswers(JSON.parse(localUserAnswers));
          }

          setExamData(data);
          const savedCountdownTime = localStorage.getItem(
            `countdownTime_${examId}`
          );

          if (!savedCountdownTime || JSON.parse(savedCountdownTime) === 0) {
            setRemainingTime(parseInt(data.time * 60 * 1000));
          } else {
            setRemainingTime(parseInt(JSON.parse(savedCountdownTime)));
          }
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        toast.error(message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [examId, isCompleted]);

  const handleChangeUserAnswersTN = (event) => {
    const { name, value } = event.target;

    // Cập nhật giá trị của TextField trong state answers
    setUserAnswers((prevAnswers) => {
      const newAnswer = { ...prevAnswers, [name]: value };
      localStorage.setItem(`userAnswers_${examId}`, JSON.stringify(newAnswer));
      return newAnswer;
    });
  };

  const handleChangeUserAnswersDS = (question, option, isCorrect) => {
    setUserAnswers((prevAnswers) => {
      const newAnswer = {
        ...prevAnswers,
        [question]: {
          ...prevAnswers[question],
          [option]: isCorrect ? "D" : "S",
        },
      };
      localStorage.setItem(`userAnswers_${examId}`, JSON.stringify(newAnswer));
      return newAnswer;
    });
  };

  const handleChangeUserAnswersMA = (e, name, question) => {

    setUserAnswers((prevAnswers) => {
      let uniqueArray = [];
      if (e.target.checked) {
        if (Array.isArray(prevAnswers[question])) {
          prevAnswers[question]?.push(name);
        } else {
          prevAnswers[question] = [name];
        }
      }
      uniqueArray = [...new Set(prevAnswers[question])];

      const newAnswer = {
        ...prevAnswers,
        [question]: e.target.checked
          ? uniqueArray
          : uniqueArray.filter((ittem) => ittem !== name),
      };
      localStorage.setItem(`userAnswers_${examId}`, JSON.stringify(newAnswer));
      return newAnswer;
    });
  };

  const handleChangeUserAnswersTLN = (event) => {
    const { name, value } = event.target;

    if (!value || value === "-") {
      setUserAnswers((prevAnswers) => {
        const newAnswer = {
          ...prevAnswers,
          [name]: value,
        };
        localStorage.setItem(
          `userAnswers_${examId}`,
          JSON.stringify(newAnswer)
        );
        return newAnswer;
      });
      return;
    }

    let numericValue = value;

    if (typeof numericValue === "string" && numericValue.includes(",")) {
      numericValue = numericValue.replace(",", ".");
    }

    if (isNumeric(numericValue)) {
      setUserAnswers((prevAnswers) => {
        const newAnswer = {
          ...prevAnswers,
          [name]: numericValue,
        };
        localStorage.setItem(
          `userAnswers_${examId}`,
          JSON.stringify(newAnswer)
        );
        return newAnswer;
      });
    }
  };

  const handleChangeUserAnswersTLN_M = (event) => {
    const { name, value } = event.target;
    let temp = name.split("-");
    if (!value || value === "-") {
      setUserAnswers((prevAnswers) => {
        let newAnswer = {};
        if (prevAnswers?.[temp[0]]) {
          newAnswer = {
            ...prevAnswers,
            [temp[0]]: { ...prevAnswers[temp[0]], [temp[1]]: value }, // Lưu giá trị dưới dạng số
          };
        } else {
          newAnswer = {
            ...prevAnswers,
            [temp[0]]: { [temp[1]]: value }, // Lưu giá trị dưới dạng số
          };
        }
        localStorage.setItem(
          `userAnswers_${examId}`,
          JSON.stringify(newAnswer)
        );
        return newAnswer;
      });
    }
    let numericValue = value;
    if (typeof numericValue === "string" && numericValue.includes(",")) {
      numericValue = numericValue.replace(",", ".");
    }
    if (isNumeric(numericValue)) {
      setUserAnswers((prevAnswers) => {
        let newAnswer = {};
        if (prevAnswers?.[temp[0]]) {
          newAnswer = {
            ...prevAnswers,
            [temp[0]]: { ...prevAnswers[temp[0]], [temp[1]]: numericValue }, // Lưu giá trị dưới dạng số
          };
        } else {
          newAnswer = {
            ...prevAnswers,
            [temp[0]]: { [temp[1]]: numericValue }, // Lưu giá trị dưới dạng số
          };
        }
        localStorage.setItem(
          `userAnswers_${examId}`,
          JSON.stringify(newAnswer)
        );
        return newAnswer;
      });
    }
  };

  // useEffect(() => {
  //   localStorage.setItem(
  //     `countdownTime_${examId}`,
  //     JSON.stringify(remainingTime)
  //   );
  // }, [remainingTime, examId]);

  const handleStartExam = async () => {
    setLoading(true);
    try {
      const results = await submitAssignment({
        examId: examId,
        userAnswers,
      });
      if (
        results &&
        results.data &&
        results.data.data &&
        results.status === 200
      ) {
        setIsStarted(true);
        setIsCompleted(false);
        setExamResult(results.data.data);
        toast.success(results.data?.message);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitExam = async () => {
    setLoading(true);
    try {
      let newUserAnswers = {};
      Object.keys(userAnswers).forEach((question) => {
        if (userAnswers[question] === "object") {
          for (const key in userAnswers[question]) {
            newUserAnswers = {
              ...newUserAnswers,
              [question]:
                userAnswers[question][key] === "0"
                  ? { ...userAnswers[question], [key]: 0 }
                  : userAnswers[key],
            };
          }
        } else {
          newUserAnswers = {
            ...newUserAnswers,
            [question]:
              userAnswers[question] === "0" ? 0 : userAnswers[question],
          };
        }
      });
      const results = await submitAssignment({
        examId: examId,
        userAnswers: newUserAnswers,
        examCompledTime: remainingTime || 0,
      });

      if (results && results.data && results.status === 200) {
        localStorage.removeItem(`countdownTime_${examId}`);
        setRemainingTime(0);
        setIsStarted(true);
        setIsCompleted(true);
        toast.success(results.data?.message);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleStartRetestExam = async () => {
    setLoading(true);
    try {
      const results = await submitAssignment({
        examId: examId,
        userAnswers,
        isReTest: true,
      });
      if (
        results &&
        results.data &&
        results.data.data &&
        results.status === 200
      ) {
        setIsStarted(true);
        setIsCompleted(false);
        setExamResult(results.data.data);
        toast.success(results.data?.message);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleViewSelectedAnswerExam = () => {
    navigate(`/exam-papers/view-selected-answer/${examId}`);
  };

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <>
      <div className="max-w-[1140px] m-auto">
        <NavbarComponent />
        <HeroWrapComponent />
      </div>
      <section
        className="ftco-section ftco-no-pb ftco-no-pt test-online"
        id="chapter-section"
      >
        <div className="Exam">
          <ExamInfo
            examData={examData}
            isStarted={isStarted}
            handleStartExam={handleStartExam}
            examResult={examResult}
          />
          <ExamContainer
            isStarted={isStarted}
            isCompleted={isCompleted}
            examData={examData}
            questions={questions}
            userAnswers={userAnswers}
            handleChangeUserAnswersTN={handleChangeUserAnswersTN}
            handleChangeUserAnswersDS={handleChangeUserAnswersDS}
            handleChangeUserAnswersMA={handleChangeUserAnswersMA}
            handleChangeUserAnswersTLN={handleChangeUserAnswersTLN}
            handleChangeUserAnswersTLN_M={handleChangeUserAnswersTLN_M}
            onDragEnd={onDragEnd}
            handleSubmitExam={handleSubmitExam}
            examResult={examResult}
            handleStartRetestExam={handleStartRetestExam}
            handleViewSelectedAnswerExam={handleViewSelectedAnswerExam}
            examResults={examResults}
            maxScore={maxScore}
            remainingTime={remainingTime}
            setRemainingTime={setRemainingTime}
            examId={examId}
            setIsCompleted={setIsCompleted}
          />
        </div>
      </section>
      <FooterComponent />
    </>
  );
};

export default ExecuteTest_TSA_Component;
